import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import {
  useDashboardContext,
} from 'Views/Dashboard/DashboardContext';
import ClientActionItems from 'Components/ClientApp/CombinedApp/Viewport/ClientActionItems';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import UpcomingNextUpTasking from 'Organisms/UpNextTaskingPicker/UpcomingNextUpTasking';

const ClientTaskItemsPicker = () => {
  const { householdResource } = useSimpleHousehold();
  const { clientDashboardResource } = useDashboardContext();

  // If action items are available then pick if we should use the what if version or not.
  return pickFunction(clientDashboardResource, {
    [fr.relationships.tasks.name]: () => {
      return <UpcomingNextUpTasking />;
    },
    [fr.relationships.default.name]: () => {
      return pickFunction(householdResource, {
        [fr.relationships.actionItems.name]: () => {
          return (
            <ClientActionItems HeaderProps={{ TitleProps: { weight: 'bold', variant: 'h1' } }} />
          );
        },
        [fr.relationships.default.name]: () => {
          return null;
        },
      });
    },
  });
};
export default ClientTaskItemsPicker;
